import { Injectable, Inject, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, NgForm } from '@angular/forms';
import { JsonConvert, ValueCheckingMode } from 'json2typescript';
import * as _ from 'lodash';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { DOCUMENT } from '@angular/common';
import {
  Router,
  NavigationEnd,
  UrlTree,
  UrlSegmentGroup,
  PRIMARY_OUTLET,
  UrlSegment,
} from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { WINDOW } from '../window.provider';
import { Globals } from '../globals';

//Only For Language
import { HttpClient } from '@angular/common/http';
import { SharedService } from 'src/app/shared.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
@Injectable()
export class GlobalService {
  private readonly newsContentStorageKey = 'newsContentUpdatedAt';
  private newsContentChangedSubject = new Subject<void>();
  public newsContentChanged$ = this.newsContentChangedSubject.asObservable();
  private roomBookingData$ = new BehaviorSubject<any>({});
  currentroomBookingData$ = this.roomBookingData$.asObservable();
  public jsonConvert: JsonConvert = new JsonConvert();
  private browserName: string;
  public showLoader: boolean = false;
  public toggleMenu: boolean = false;
  public hotelName = '';
  public toggleUserMenu: boolean = true;
  private loginSubject = new Subject<void>();
  login$ = this.loginSubject.asObservable();
  public subjectName = new Subject<any>(); //need to create a subject
  private emailSubject = new BehaviorSubject<string>(null);
  email$ = this.emailSubject.asObservable();
  private editServiceViewEmitter = new Subject<number>();
  editServiceViewEmitted$ = this.editServiceViewEmitter.asObservable();
  private editResturantViewEmitter = new Subject<number>();
  editResturantViewEmitted$ = this.editResturantViewEmitter.asObservable();
  private countMessageSource = new BehaviorSubject<any>(null);
  countMessage = this.countMessageSource.asObservable();
   private bookingData = new BehaviorSubject<any>(null);
  currentBookingData = this.bookingData.asObservable();
  
  setBookingData(data: any) {
    this.bookingData.next(data);
  }
  constructor(
    private router: Router,
    private toaster: ToastrService,
    @Inject(DOCUMENT) private document: any,
    @Inject(WINDOW) private window: Window,
    public globals: Globals,
    private http: HttpClient,
    private sharedService: SharedService,
    private translate: TranslateService
  ) {
    this.jsonConvert.valueCheckingMode = ValueCheckingMode.ALLOW_NULL;
    this.jsonConvert.valueCheckingMode = ValueCheckingMode.ALLOW_OBJECT_NULL;
    this.browserName = this.getBrowserName().toLowerCase();
    this.window.addEventListener('storage', (event: StorageEvent) => {
      if (event.key === this.newsContentStorageKey) {
        this.newsContentChangedSubject.next();
      }
    });
  }

  notifyNewsContentChanged() {
    this.newsContentChangedSubject.next();
    try {
      this.window.localStorage.setItem(
        this.newsContentStorageKey,
        `${Date.now()}-${Math.random()}`
      );
    } catch {
      // The in-app event above still refreshes news when browser storage is unavailable.
    }
  }

  setRoomBookingData(data: any) {
    this.roomBookingData$.next(data);
  }
  changeMessage(message: any) {
    this.countMessageSource.next(message);
  }
  emitEditServiceView(id: number) {
    this.editServiceViewEmitter.next(id);
  }
  emitEditResturantView(resturantId: number) {
    this.editResturantViewEmitter.next(resturantId);
  }
  setBookingsData(data: any) {
    this.bookingData.next(data);
  }
  getFirstUrlSegment() {
    const tree: UrlTree = this.router.parseUrl(window.location.pathname);
    const g: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];

    if (g) {
      const s: UrlSegment[] = g.segments;
      return s[0].path;
    } else {
      return '/';
    }
  }
  

  notifyLogin() {
    this.loginSubject.next();
  }

  getHostname(): string {
    if ('localhost' == this.window.location.hostname) {
      //return  'cityhotelxs.softobiz.biz';
      // return  'villlafontera.softobiz.biz';
      return environment.SubDomainLocal;
    } else {
      return this.window.location.hostname;
    }
  }

  isPortalRestaurantOrderRoute(): boolean {
    const path = this.router.url.split('?')[0];
    return this.isPortalStaffRoute() &&
      /\/restaurants\/[^/]+\/order(?:\/|$)/.test(path);
  }

  isPortalStaffRoute(): boolean {
    return this.router.url.startsWith('/portal/staff/');
  }

  getPortalManageRestaurantsRoute(...segments: any[]): any[] {
    const [portal, role] = this.router.url.split('?')[0].split('/').filter(Boolean);
    return ['/portal', portal === 'portal' && role ? role : 'admin',
      'restaurants', ...segments];
  }

  getPortalRestaurantOrderRoute(restaurantId: any, ...segments: any[]): any[] {
    return this.getPortalManageRestaurantsRoute(
      restaurantId,
      'order',
      ...segments
    );
  }

  getAiChatbotUrl() {
    return environment.aiApiUrl;
  }
  getAiChatbotKey() {
    return environment.aiApiKey;
  }
  gethotelLangTranslate(): string {
    if (!window.localStorage['hotelLangTranslate']) {
      return this.globals.hotelLangTranslate;
    } else {
      return window.localStorage['hotelLangTranslate'];
    }
  }

  getuserLangTranslate(): string {
    if (!window.localStorage['userLangTranslate']) {
      return this.globals.userLangTranslate;
    } else {
      return window.localStorage['userLangTranslate'];
    }
  }

  getLangSaveProperty() {
    if (!window.localStorage['langSaveProperty']) {
      return this.globals.langSaveProperty;
    } else {
      return window.localStorage['langSaveProperty'];
    }
  }
  getLangSaveValue() {
    if (!window.localStorage['langSaveValue']) {
      return this.globals.langSaveValue;
    } else {
      return window.localStorage['langSaveValue'];
    }
  }

  localizedArrayValue(
    langs: Array<{ Lang?: string; Value?: string }> | undefined | null,
    lang: string
  ): string {
    if (!langs || !langs.length) {
      return '';
    }
    const found = langs.find((entry) => String(entry?.Lang) === String(lang));
    return found?.Value ?? '';
  }

  getLangAccToUser() {
    var langSelect = 'en';

    if (this.HasAuthToken()) {
      //
      if (this.getFirstUrlSegment() == 'portal') {
        langSelect = this.gethotelLangTranslate();
      } else {
        langSelect = this.getuserLangTranslate();
      }
    } else {
      langSelect = this.getuserLangTranslate();
    }

    return langSelect;
  }

  loginFirst() {
    this.toaster.error(
      this.translateMessage('PleaseLoginToBookRooms', 'Please Login to Book Rooms'),
      null,
      { timeOut: 5000 }
    );
  }

  NoData() {
    this.toaster.error(
      this.translateMessage('PleaseEnterDataForApplyingFilter', 'Please Enter Data for applying filter'),
      null,
      {
      timeOut: 5000,
      }
    );
  }

  enterValidNumber() {
    this.toaster.error(
      this.translateMessage('PleaseEnterValidPhoneNumber', 'Please Enter Valid Phone Number'),
      null,
      {
      timeOut: 5000,
      }
    );
  }

  editItemFirst() {
    this.toaster.error(
      this.translateMessage('PleaseSaveTheEditItemFirst', 'Please save the edit item first...'),
      null,
      {
      timeOut: 5000,
      }
    );
  }

  resendOtp() {
    this.toaster.info(
      this.translateMessage('YouCanResendOTPAfter60s', 'You can resend OTP after 60s'),
      null,
      { timeOut: 5000 }
    );
  }
  resetComponent() {
    this.router
      .navigateByUrl('/RefrshComponent', { skipLocationChange: true })
      .then(() => this.router.navigate([window.location.pathname]));
  }

  toggleLoader() {
    this.showLoader = !this.showLoader;
  }

  toggleAdminMenuSidenav(data) {
    this.toggleMenu = data;
    this.updateMobileNavigationScrollLock(data);
  }
  toggleUserMenuSidenav(data) {
    this.toggleUserMenu = data;
    this.updateMobileNavigationScrollLock(data);
  }
  private updateMobileNavigationScrollLock(isOpen: boolean) {
    const className = 'mobile-navigation-open';
    const shouldLock = isOpen && this.window.innerWidth <= 1080;
    this.document.documentElement.classList.toggle(className, shouldLock);
    this.document.body.classList.toggle(className, shouldLock);
  }

  getToggleAdminMenuSidenav() {
    return this.toggleMenu;
  }
  getToggleUserMenuSidenav() {
    return this.toggleUserMenu;
  }

  setHotelNameUpdate(message: string) {
    this.subjectName.next({ text: message }); //next() will feed the value in Subject
  }

  getHotelNameUpdate(): Observable<any> {
    //the receiver component calls this function
    return this.subjectName.asObservable(); //it returns as an observable to which the receiver funtion will subscribe
  }

  getUrlRest() {
    const url = this.router.url;
    const urlParts = url.split('/');
    if (
      urlParts.length == 4 &&
      urlParts[1] == 'restaurants' &&
      urlParts[3] == 'true'
    ) {
      return false;
    } else if (
      urlParts.length == 5 &&
      urlParts[1] == 'cart' &&
      urlParts[2] == 'resturant' &&
      urlParts[4] == 'true'
    ) {
      return false;
    } else {
      return true;
    }
  }

  //hideloader
  hideLoader() {
    this.showLoader = false;
  }

  addClassToBody(className) {
    this.document.body.classList.add(className);
  }

  removeClassFromBody(className) {
    this.document.body.classList.remove(className);
  }

  private translateMessage(key: string, fallback: string, params?: any): string {
    const translatedMessage = this.translate.instant(key, params);
    return translatedMessage && translatedMessage !== key
      ? translatedMessage
      : fallback;
  }

  handleErrorMessage(msg) {
    const shouldSuppressErrorToast =
      window.sessionStorage.getItem('suppressGlobalErrorToast') === 'true' ||
      window.location.pathname.startsWith('/page-not-found');

    if (shouldSuppressErrorToast) {
      return;
    }

    if (!this.validateIsEmpty(msg)) {
      this.toaster.error(msg, null, { timeOut: 5000 });
    } else {
      this.toaster.error(
        this.translateMessage('ErrorOccured', 'Error occured'),
        null,
        { timeOut: 5000 }
      );
    }
  }

  handleWarningMessage(msg) {
    if (!this.validateIsEmpty(msg)) {
      this.toaster.warning(msg, null, { timeOut: 5000 });
    } else {
      this.toaster.warning(
        this.translateMessage('ErrorOccured', 'Error occured'),
        null,
        { timeOut: 5000 }
      );
    }
  }

  handleSuccessMessage(msg) {
    if (!this.validateIsEmpty(msg)) {
      this.toaster.success(msg, null, { timeOut: 3000 });
    }
  }
  signUpSuccessMessage(msg) {
    this.toaster.success(
      msg + ' ' + this.translateMessage('Successfull', 'Successfull'),
      null,
      { timeOut: 3000 }
    );
  }

  onChangeDateGuestNo() {
    this.toaster.info(
      this.translateMessage('PleaseSelectRoomTypeAndRoomNameAgain', 'Please Select Room Type and Room Name again'),
      null,
      {
      timeOut: 3000,
      }
    );
  }

  categoryNameTooSmall() {
    this.toaster.error(
      this.translateMessage('CategoryNameMustBeBetween3To30Characters', 'Category Name must be between 3 to 30 characters'),
      null,
      { timeOut: 3000 }
    );
  }

  itemNameTooSmall() {
    this.toaster.error(
      this.translateMessage('ItemNameMustBeBetween3To30Characters', 'Item Name must be between 3 to 30 characters'),
      null,
      {
      timeOut: 3000,
      }
    );
  }

  enterValidInput() {
    this.toaster.error(
      this.translateMessage('PleaseEnterValidInputInSearch', 'Please Enter Valid Input in Search'),
      null,
      {
      timeOut: 3000,
      }
    );
  }

  itemQuantityTooSmall() {
    this.toaster.error(
      this.translateMessage('ItemQuantityShouldBeFrom1To9999PleaseEnterValidQuantity', 'Item Quantity Should be from 1 To 9999. Please Enter Valid Quantity'),
      null,
      { timeOut: 3000 }
    );
  }

  itemPriceTooSmall() {
    this.toaster.error(
      this.translateMessage('ItemPriceShouldBeFrom0_1To999999PleaseEnterValidPrice', 'Item Price Should be from 0.1 To 999999. Please Enter Valid Price'),
      null,
      { timeOut: 3000 }
    );
  }

  noOfGuestsInvalid() {
    this.toaster.error(
      this.translateMessage('NoOfGuestShouldBeBetween1To10', 'No. of guest should be between 1 to 10'),
      null,
      {
      timeOut: 3000,
      }
    );
  }

  inventoryManage() {
    this.toaster.error(
      this.translateMessage('PleaseCheckTheTrackInventoryCheckboxForActivatingQuantity', 'Please check the Track Inventory checkbox for activating Quantity.'),
      null,
      { timeOut: 3000 }
    );
  }

  alreadyCheckIn() {
    this.toaster.error(
      this.translateMessage('YouAreAlreadyCheckedIn', 'You are already checked in!'),
      null,
      { timeOut: 5000 }
    );
  }

  handleInfoMessage(msg) {
    if (!this.validateIsEmpty(msg)) {
      this.toaster.info(msg[this.getLangAccToUser()], null, { timeOut: 3000 });
    }
  }

  handleCanNotDoPaymentMessage() {
    this.toaster.info(
      this.translateMessage('PleaseSelectItemForPayment', 'Please Select item for Payment'),
      null,
      {
      timeOut: 5000,
      }
    );
  }
  handleSearchError() {
    this.toaster.info(
      this.translateMessage('PleaseSelectCheckinAndCheckoutDate', 'Please Select Checkin and Checkout date'),
      null,
      {
        timeOut: 3000,
      }
    );
  }

  handleNoAmount() {
    this.toaster.info(
      this.translateMessage('NoAmountToPay', 'No Amount To Pay'),
      null,
      { timeOut: 5000 }
    );
  }

  serviceStatus() {
    this.toaster.info(
      this.translateMessage('NoPayableServiceRequestStatusPendingPleaseWait', 'No Payable Service, Request Status Pending. Please Wait'),
      null,
      { timeOut: 5000 }
    );
  }

  allNotPayable(data) {
    this.toaster.info(
      this.translateMessage('AllBillsAreNotPayable', `All ${data} bills are not Payable`, {
        data,
      }),
      null,
      {
      timeOut: 5000,
      }
    );
  }

  notPayable(data, product) {
    let status;
    if (data.progressStatus == 1) {
      status = this.translateMessage('Open', 'Open');
    } else if (data.progressStatus == 5) {
      status = this.translateMessage('Closed', 'Closed');
    }
    this.toaster.info(
      this.translateMessage(
        'ThisBillIsNotPayableRequestStatusIs',
        `This ${product} bill is not Payable Request Status is ${status}`,
        {
          product,
          status,
        }
      ),
      null,
      { timeOut: 5000 }
    );
  }

  // rangeError() {
  //   this.toaster.info("Please add some Range data first", null, {timeOut: 3000});
  // }
  rangeDataExist() {
    this.toaster.error(
      this.translateMessage('ThisRangeAlreadyExists', 'This Range Already Exists'),
      null,
      { timeOut: 3000 }
    );
  }

  enterCorrectRange() {
    this.toaster.error(
      this.translateMessage('PleaseEnterCorrectRange', 'Please Enter Correct Range'),
      null,
      { timeOut: 5000 }
    );
  }
  setEmail(email: string) {
    this.emailSubject.next(email);
  }

  NoInput() {
    this.toaster.error(
      this.translateMessage('NoInputPleaseEnterRoomNoToAdd', 'No Input! Please Enter Room no. to add'),
      null,
      {
      timeOut: 5000,
      }
    );
  }

  WrongInput() {
    this.toaster.error(
      this.translateMessage('NoInputPleaseSelectStaffForAssigning', 'No Input! Please select staff for assigning'),
      null,
      {
      timeOut: 5000,
      }
    );
  }
  sameRange() {
    this.toaster.error(
      this.translateMessage('SameRangePleaseChangeTheInput', 'Same Range!! Please Change the input'),
      null,
      {
      timeOut: 5000,
      }
    );
  }

  paymentMethodNotAvailable(method) {
    this.toaster.info(
      this.translateMessage(
        'PleaseChooseAnotherOptionForPaymentMethodUnavailable',
        `Please Choose another option for Payment, ${method} is unavailable for now.`,
        { method }
      ),
      null,
      { timeOut: 5000 }
    );
  }

  messageLength(data) {
    this.toaster.error(
      this.translateMessage(
        'YourMessageExceedsTheMaxLengthForMessageBy',
        `Your Message Exceeds the max length for message by: ${data}`,
        { data }
      ),
      null,
      { timeOut: 5000 }
    );
  }

  checkInDateGreater() {
    this.toaster.error(
      this.translateMessage(
        'PleaseGiveValidCheckInDateCheckInDateCannotBeGreaterThanCheckOutDate',
        'Please Give Valid Check in Date. Check in date cannot be Greater then CheckOut Date'
      ),
      null,
      { timeOut: 5000 }
    );
  }

  checkInDateLessThenCurrent() {
    this.toaster.error(
      this.translateMessage(
        'PleaseGiveValidCheckInDateCheckInDateAlreadyPassedTodayDate',
        "Please Give Valid Check in Date. Check in date already passed today's date"
      ),
      null,
      { timeOut: 5000 }
    );
  }

  guestValidator(Guests) {
    this.toaster.error(
      this.translateMessage(
        'NoOfGuestAllowedInThisRoomIsPleaseEnterCorrectGuestNo',
        `No of Guest Allowed in this Room is ${Guests} .Please Enter Correct Guest No.`,
        { Guests }
      ),
      null,
      { timeOut: 5000 }
    );
  }

  guestConformation(Guests) {
    this.toaster.error(
      this.translateMessage('OnlyGuestsAreAllowed', `Only ${Guests} Guests are allowed.`, {
        Guests,
      }),
      null,
      {
      timeOut: 5000,
      }
    );
  }

  // messageLength(data){
  //   this.toaster.error("Your Message Exceeds the max length for message by: " + data, null, {timeOut: 5000});
  // }

  paymentSuccessfull() {
    this.toaster.success(
      this.translateMessage('YourPaymentIsSuccessfull', 'Your Payment is Successfull'),
      null,
      {
      timeOut: 5000,
      }
    );
  }

  roomAvailable() {
    this.toaster.error(
      this.translateMessage('ThisRoomIsNotAvailableOnYourSelectedDates', 'this room is not available on your selected dates'),
      null,
      { timeOut: 5000 }
    );
  }

  estimateTimeNeeded() {
    this.toaster.error(
      this.translateMessage('PleaseEnterTheEstimatedTimeBeforeMovingToPreparing', 'Please enter the estimated Time before moving to preparing'),
      null,
      { timeOut: 5000 }
    );
  }

  assignedStaffNeed(Location) {
    this.toaster.error(
      this.translateMessage(
        'PleaseAssignStaffBeforeMovingToLocation',
        `Please assign Staff before moving to ${Location}.`,
        { Location }
      ),
      null,
      { timeOut: 5000 }
    );
  }

  handleApiError(input, submit: boolean = null) {
    const shouldSuppressErrorToast =
      window.sessionStorage.getItem('suppressGlobalErrorToast') === 'true' ||
      window.location.pathname.startsWith('/page-not-found');

    if (shouldSuppressErrorToast) {
      return;
    }

    if (
      !this.validateIsEmpty(input) &&
      !this.validateIsEmpty(input.error) &&
      !this.validateIsEmpty(input.error.Errors)
    ) {
      const nestedErrors = input.error.Errors;
      if (submit) {
        if (Array.isArray(nestedErrors)) {
          for (let i = 0; i < nestedErrors.length; i++) {
            const message =
              nestedErrors[i]?.Message ||
              nestedErrors[i]?.message ||
              nestedErrors[i]?.Value ||
              nestedErrors[i];
            if (!this.validateIsEmpty(message)) {
              this.handleErrorMessage(message);
            }
          }
        } else if (typeof nestedErrors === 'string') {
          this.handleErrorMessage(nestedErrors);
        } else if (
          !this.validateIsEmpty(nestedErrors.Message) ||
          !this.validateIsEmpty(nestedErrors.message)
        ) {
          this.handleErrorMessage(
            nestedErrors.Message || nestedErrors.message
          );
        }
      }

      //
      //As we are maintaining two Auth tokens
      // if (!this.HasAuthToken()) {
      //   this.DeleteAuthToken();
      // }

      //Token failed error-----------------
      if (input.error.Message) {
        if (input.error.Message.toString() == 'Token Failed') {
          this.DeleteAuthToken();
        }
      }

      //Auth raw errors  500--------------
      if (nestedErrors.raw) {
        this.handleErrorMessage(nestedErrors.raw.message);
      } else {
        //TokenExpiredError
        if (nestedErrors.name) {
          if (nestedErrors.name.toString() == 'TokenExpiredError') {
            this.DeleteAuthToken();
          }
          if (
            nestedErrors.name.toString() == 'CheckInTokenExpiredError'
          ) {
            this.deleteGuestAuthToken();
          }
        }
      }

      //Stripe errors-----------------------
      if (nestedErrors.stripe) {
        this.handleErrorMessage(nestedErrors.stripe);
        return false;
      }

      //Already exists-----------------------
      if (input.Message == 'Already Exists') {
        this.handleErrorMessage(input.Message);
      }
    } else if (
      !this.validateIsEmpty(input) &&
      !this.validateIsEmpty(input.error) &&
      !this.validateIsEmpty(input.error.Message)
    ) {
      const errorMessage = String(input.error.Message);

      if (errorMessage === 'Token Failed') {
        this.DeleteAuthToken();
      } else if (errorMessage === 'Guest Token Failed') {
        this.deleteGuestAuthToken();
      } else {
        // Business API errors (HTTP non-2xx body Message), e.g. checklist recurrence lock
        this.handleErrorMessage(input.error.Message);
      }
    } else if (
      !this.validateIsEmpty(input) &&
      !this.validateIsEmpty(input.Errors)
    ) {
      if (input.Errors == 'AlreadyRegistered') {
        this.handleErrorMessage(input.Message);
        this.router.navigate(['/portal']);
      } else if (typeof input.Errors === 'string') {
        this.handleErrorMessage(input.Errors);
      } else if (
        !Array.isArray(input.Errors) &&
        (!this.validateIsEmpty(input.Errors?.Message) ||
          !this.validateIsEmpty(input.Errors?.message))
      ) {
        this.handleErrorMessage(input.Errors.Message || input.Errors.message);
      } else if (Array.isArray(input.Errors) && input.Errors.length > 0) {
        for (let i = 0; i < input.Errors.length; i++) {
          this.handleErrorMessage(input.Errors[i].Message);
        }
      } else if (!this.validateIsEmpty(input.Message)) {
        // Errors: [] but Message present (business rule failures)
        this.handleErrorMessage(input.Message);
      }
    } else if (
      !this.validateIsEmpty(input) &&
      !this.validateIsEmpty(input.Message)
    ) {
      this.handleErrorMessage(input.Message);
    } else {
      this.http
        .get('assets/portal/i18n/' + this.getLangAccToUser() + '.json', {
          responseType: 'json',
        })
        .subscribe((data) =>
          this.handleErrorMessage(data['ServerErrors']['somethingWentWrong'])
        );
    }
  }

  downloadFileWithURL(fileURL, fileName) {
    let a = document.createElement('a');
    a.setAttribute('style', 'display:none');
    a.setAttribute('href', fileURL);
    a.setAttribute('download', fileName);
    document.body.appendChild(a);
    a.click();

    setTimeout(function () {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(fileURL);
    }, 100);
  }

  downloadFileWithBlob(fileBlob, fileName) {
    let fileURL = URL.createObjectURL(fileBlob);
    let a = document.createElement('a');
    a.setAttribute('style', 'display:none');
    a.setAttribute('href', fileURL);
    a.setAttribute('download', fileName);
    document.body.appendChild(a);
    a.click();

    setTimeout(function () {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(fileURL);
    }, 100);
  }

  cloneData(data, defaultReturn: string = '') {
    if (!this.validateIsEmpty(data)) {
      return _.cloneDeep(data);
    } else {
      return defaultReturn;
    }
  }

  HasAuthToken(): boolean {
    if (
      window.sessionStorage['AUTH_TOKEN'] ||
      window.localStorage['AUTH_TOKEN']
    ) {
      return true;
    } else {
      return false;
    }
  }

  hasCheckInAuthToken(): boolean {
    if (
      window.sessionStorage['CheckIn_TOKEN'] ||
      window.localStorage['CheckIn_TOKEN']
    ) {
      return true;
    } else {
      return false;
    }
  }

  hasLoginInAuthToken(): boolean {
    if (
      window.sessionStorage['LogIn_TOKEN'] ||
      window.localStorage['LogIn_TOKEN']
    ) {
      return true;
    } else {
      return false;
    }
  }

  pruneLocalStorage(allowedKeys: string[] = []) {
    const keep = new Set(allowedKeys || []);
    Object.keys(window.localStorage).forEach((key: string) => {
      if (!keep.has(key)) {
        window.localStorage.removeItem(key);
      }
    });
  }

  DeleteAuthToken(): void {
    window.localStorage.removeItem('AUTH_TOKEN');
    window.sessionStorage.removeItem('AUTH_TOKEN');
    window.localStorage.removeItem('bulkPermissions');

    this.router.navigate(['/portal']);
  }

  deleteGuestAuthToken(): void {
    window.localStorage.removeItem('CheckIn_TOKEN');
    window.localStorage.removeItem('LogIn_TOKEN');
    window.sessionStorage.removeItem('CheckIn_TOKEN');
    window.sessionStorage.removeItem('LogIn_TOKEN');

    this.router.navigate(['/']);
  }

  deleteCheckInAuthToken() {
    window.localStorage.removeItem('CheckIn_TOKEN');
    window.sessionStorage.removeItem('CheckIn_TOKEN');
    this.router.navigate(['/']);
  }

  deleteLogInAuthToken() {
    window.localStorage.removeItem('LogIn_TOKEN');
    window.sessionStorage.removeItem('LogIn_TOKEN');
    this.router.navigate(['/']);
  }
  deleteLogInAuthTokenGuest() {
    window.localStorage.removeItem('LogIn_TOKEN');
    window.sessionStorage.removeItem('LogIn_TOKEN');
    window.localStorage.removeItem('CheckIn_TOKEN');
    window.sessionStorage.removeItem('CheckIn_TOKEN');
    // Logging out on the homepage does not recreate it, so tell listeners
    // that the login state changed.
    this.notifyLogin();
    this.router.navigate(['/']);
  }

  // validateFormFields(formGroup: FormGroup) {
  //   let formErrors = [];
  //   Object.keys(formGroup.controls).forEach(field => {
  //     const control = formGroup.get(field);
  //     if (control instanceof FormControl) {
  //       if (control.invalid) {
  //         const errors = Object.keys(control.errors);
  //         for (let j = 0; j < errors.length; j++) {
  //           formErrors.push({ Field: field, Message: field + " " + errors[j] });
  //         }
  //       }
  //       control.markAsTouched({ onlySelf: true });
  //     }
  //     else if (control instanceof FormGroup) {
  //       this.validateFormFields(control);
  //     }
  //   });
  //   return formErrors;
  // }

  validateFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateFormFields(control);
      }
    });
  }

  containFormError(form: NgForm, ctrlName) {
    let formErrors = [];
    try {
      if (form.form.controls[ctrlName].invalid) {
        const errors = Object.keys(form.form.controls[ctrlName].errors);
        for (let i = 0; i < errors.length; i++) {
          formErrors.push(ctrlName + ' ' + errors[i]);
        }
      }
      return formErrors;
    } catch (error) {
      return formErrors;
    }
  }

  getActivatedRoute(): Observable<any> {
    return Observable.create((observer) => {
      this.router.events.subscribe((val) => {
        if (val instanceof NavigationEnd) {
          const route =
            val.urlAfterRedirects.split('/')[
              val.urlAfterRedirects.split('/').length - 1
            ];
          observer.next(route);
        }
      });
    });
  }

  getPreciseAge(date): string {
    if (!this.validateIsEmpty(date)) {
      let currentDate = new Date();
      let dateOfBirth = new Date(date);
      let age: string = '';
      let year = currentDate.getFullYear() - dateOfBirth.getFullYear();
      let month = currentDate.getMonth() - dateOfBirth.getMonth();
      let currentDayDate = currentDate.getDate();
      let birthDayDate = dateOfBirth.getDate();

      if (month == 0 && currentDayDate < birthDayDate) {
        year = year - 1;
        month = 11;
      } else if (month < 0) {
        year = year - 1;
        month = 12 - Math.abs(month);
      }

      if (year != 0) {
        age = age + year.toString() + ' Years';
      }

      if (month != 0) {
        if (age != '') {
          age = age + ' ' + month.toString() + ' Months';
        } else {
          age = age + month.toString() + ' Months';
        }
      }

      return age;
    } else {
      return '';
    }
  }

  concatFnameLname(fname, lname) {
    if (!this.validateIsEmpty(fname) && !this.validateIsEmpty(lname)) {
      return fname.toString() + ' ' + lname.toString();
    } else if (!this.validateIsEmpty(fname)) {
      return fname.toString();
    } else {
      return '';
    }
  }

  concatAddress(address, city, zipcode, state, country) {
    let completeAddress = [address, city, zipcode, state, country];
    completeAddress = completeAddress.filter((obj) => {
      if (!this.validateIsEmpty(obj)) {
        return obj;
      }
    });
    return completeAddress.join(', ');
  }

  printNameWithPost(fname, lname, post) {
    let fullName: string = '';
    if (this.validateIsEmpty(fname)) {
      return '';
    } else {
      if (!this.validateIsEmpty(fname) && !this.validateIsEmpty(lname)) {
        fullName = fullName + fname + ' ' + lname;
      } else {
        fullName = fullName + fname;
      }
      if (this.validateIsEmpty(post)) {
        return fullName;
      } else {
        return [fullName, post].join(', ');
      }
    }
  }

  checkBrowserCompatibility(notAllowedBrowsers) {
    return notAllowedBrowsers.filter((browser) => {
      if (this.browserName.search(browser) !== -1) {
        return browser;
      }
    });
  }

  getBrowserName() {
    var ua = navigator.userAgent,
      tem,
      M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return 'IE ' + (tem[1] || '');
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(' ');
  }

  upgradeDateByDays(date, counter) {
    let incomingDate: Date = _.cloneDeep(date);
    return new Date(incomingDate.setDate(incomingDate.getDate() + counter));
  }

  upgradeDateByMonths(date, counter) {
    let incomingDate: Date = _.cloneDeep(date);
    return new Date(incomingDate.setMonth(incomingDate.getMonth() + counter));
  }

  upgradeDateByYears(date, counter) {
    let incomingDate: Date = _.cloneDeep(date);
    return new Date(
      incomingDate.setFullYear(incomingDate.getFullYear() + counter)
    );
  }

  downgradeDateByDays(date, counter) {
    let incomingDate: Date = _.cloneDeep(date);
    return new Date(incomingDate.setDate(incomingDate.getDate() - counter));
  }

  downgradeDateByMonths(date, counter) {
    let incomingDate: Date = _.cloneDeep(date);
    return new Date(incomingDate.setMonth(incomingDate.getMonth() - counter));
  }

  downgradeDateByYears(date, counter) {
    let incomingDate: Date = _.cloneDeep(date);
    return new Date(
      incomingDate.setFullYear(incomingDate.getFullYear() - counter)
    );
  }

  convertTimeFormat(oldTimeFormat) {
    if (this.validateIsEmpty(oldTimeFormat)) {
      return;
    } else {
      let newTimeFormat = oldTimeFormat
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [oldTimeFormat];
      if (newTimeFormat.length > 1) {
        newTimeFormat = newTimeFormat.slice(1);
        newTimeFormat[5] = +newTimeFormat[0] < 12 ? ' am' : ' pm';
        newTimeFormat[0] = +newTimeFormat[0] % 12 || 12;
      }
      let array = Object.values(newTimeFormat);
      array.splice(3, 1);
      return array.join('');
    }
  }

  validateImageSize(file: File, minWidth, minHeight): Observable<any> {
    return Observable.create((observer) => {
      let newImage: any = new Image();
      let fileReader: FileReader = new FileReader();
      fileReader.onloadend = function (loadEvent: any) {
        newImage.src = loadEvent.target.result;
        newImage.onload = function () {
          if (newImage.width >= minWidth && newImage.height >= minHeight) {
            observer.next({
              status: true,
              width: newImage.width,
              height: newImage.height,
              image: newImage,
            });
          } else {
            observer.next({
              status: false,
            });
          }
        };
      };
      fileReader.readAsDataURL(file);
    });
  }

  dataURLtoBlob(dataURI): Observable<any> {
    return Observable.create((observer) => {
      var byteString = atob(dataURI.split(',')[1]);
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      var blob = new Blob([ab], { type: mimeString });
      observer.next({
        data: blob,
      });
    });
  }

  compressImage(
    image,
    fileType,
    maxWidth,
    imageWidth,
    imageHeight
  ): Observable<any> {
    return Observable.create((observer) => {
      let originalWidth = imageWidth;
      let originalHeight = imageHeight;
      let ratio = originalHeight / originalWidth;
      if (originalWidth > maxWidth) {
        originalWidth = maxWidth;
        originalHeight = ratio * maxWidth;
      }
      let canvas = document.createElement('canvas');
      let compressedImage = new Image();
      canvas.width = originalWidth;
      canvas.height = originalHeight;
      canvas
        .getContext('2d')
        .drawImage(image, 0, 0, originalWidth, originalHeight);
      compressedImage.src = canvas.toDataURL(fileType, 1);
      observer.next({
        status: true,
        data: {
          image: compressedImage,
          width: originalWidth,
          height: originalHeight,
        },
      });
    });
  }

  convertIntIntoFixedDecimal(number: number, range) {
    return number.toFixed(range);
  }

  // Mechanism By Which We Can Simply Solve Issue of (Selected Date - 1)
  //
  // this.model.DOB.setMinutes((this.model.DOB.getTimezoneOffset() * -1));
  //

  integralTimePart(time, type) {
    return parseInt(time.split(':')[type]);
  }

  timeSlotIntersection(o1_startTime, o1_endTime, o2_startTime, o2_endTime) {
    let o1_StartTime =
      this.integralTimePart(o1_startTime, 0) * 60 +
      this.integralTimePart(o1_startTime, 1);
    let o1_EndTime =
      this.integralTimePart(o1_endTime, 0) * 60 +
      this.integralTimePart(o1_endTime, 1);
    let o2_StartTime =
      this.integralTimePart(o2_startTime, 0) * 60 +
      this.integralTimePart(o2_startTime, 1);
    let o2_EndTime =
      this.integralTimePart(o2_endTime, 0) * 60 +
      this.integralTimePart(o2_endTime, 1);

    if (
      (o2_StartTime >= o1_StartTime && o2_StartTime < o1_EndTime) ||
      (o2_EndTime > o1_StartTime && o2_EndTime <= o1_EndTime)
    ) {
      return false;
    } else {
      return true;
    }
  }

  validateIsEmpty(input, list: Array<String> = []) {
    if ((typeof input).toLowerCase() == 'boolean') {
      return false;
    } else if (input != undefined && input != null && input != '') {
      if (input instanceof Date) {
        return false;
      } else if (Array.isArray(input) && input.length != 0) {
        return false;
      } else if ((typeof input).toLowerCase() == 'object') {
        let isedit = false;
        Object.keys(input).map((key) => {
          if (
            list.indexOf(key.toString()) == -1 &&
            input[key] != undefined &&
            input[key] != null &&
            input[key] != ''
          ) {
            isedit = true;
          }
        });
        if (isedit) {
          return false;
        } else {
          return true;
        }
      } else if (
        (typeof input).toLowerCase() == 'string' &&
        input.length != 0
      ) {
        return false;
      } else if ((typeof input).toLowerCase() == 'number') {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  validateObjectIsEmpty(input) {
    if ((typeof input).toLowerCase() == 'object') {
      if (Array.isArray(input) && input.length != 0) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  checkObjectEquality(o1, o2, key = null) {
    let o1PropNames = Object.getOwnPropertyNames(o1);
    let o2PropNames = Object.getOwnPropertyNames(o2);
    if (o1PropNames.length !== o2PropNames.length) {
      return false;
    }
    for (let i = 0; i < o1PropNames.length; i++) {
      if (key != null && o1PropNames[i] == key) {
        continue;
      }
      if (o1[o1PropNames[i]] != o2[o1PropNames[i]]) {
        return false;
      }
    }
    return true;
  }

  getDefaultval() {
    return 'N/A';
  }

  validateIsEmptyAndSetDefVal(input) {
    if (this.validateIsEmpty(input)) {
      return this.getDefaultval();
    } else {
      return input;
    }
  }

  componentDestroyed(component: OnDestroy) {
    const oldNgOnDestroy = component.ngOnDestroy;
    const destroyed$ = new ReplaySubject<void>(1);
    component.ngOnDestroy = () => {
      oldNgOnDestroy.apply(component);
      destroyed$.next(undefined);
      destroyed$.complete();
    };
    return destroyed$;
  }

  formatPhoneNumber(phoneNumberString) {
    var match = phoneNumberString.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return +match[1] + '-' + match[2] + '-' + match[3];
    }
    return '';
  }

  formattedPhoneNumber(input) {
    if (Array.isArray(input) && input.length > 0) {
      let primeNumber = input.find((item) => item.IsPrimary == 1);
      let formattedNumber = this.formatPhoneNumber(primeNumber.PhoneNumber);
      if (
        !this.validateIsEmpty(primeNumber) &&
        !this.validateIsEmpty(formattedNumber)
      ) {
        return '+' + primeNumber.PhoneCountryCode + '-' + formattedNumber;
      } else {
        return this.getDefaultval();
      }
    } else if (
      (typeof input).toLowerCase() == 'object' &&
      !this.validateIsEmpty(input) &&
      !this.validateIsEmpty(this.formatPhoneNumber(input.PhoneNumber))
    ) {
      return (
        '+' +
        input.PhoneCountryCode +
        '-' +
        this.formatPhoneNumber(input.PhoneNumber)
      );
    } else {
      return this.getDefaultval();
    }
  }

  //Truncate String
  truncate(str, no_words) {
    return str.split(' ').splice(0, no_words).join(' ');
  }

  //Concatenate path for Lang translate
  concatenate(panel, language) {
    return panel + '-' + language;
  }

  //Emit Broadcast Permission Details---------------------------------
  emitPermissions(bulkPermissions) {
    if (!this.validateIsEmpty(bulkPermissions)) {
      //If not Empty then emit
      //

      window.localStorage['bulkPermissions'] = JSON.stringify(bulkPermissions);
      this.sharedService.permissionEvent.emit(bulkPermissions);
    }
  }

  emitGuestPermissions(permissions) {
    if (!this.validateIsEmpty(permissions)) {
      window.localStorage['guestPermissions'] = JSON.stringify(permissions);
      this.sharedService.guestPermissionEvent.emit(permissions);
    }
  }

  //Emit Perference Details---------------------------------
  emitPreferenceEvent(perferenceData) {
    this.sharedService.preferenceEvent.emit(perferenceData);
  }
  editPreference(perferenceData) {
    this.sharedService.editPreferenceEvent.emit(perferenceData);
  }
  emitRemovePreference(perferenceData) {
    this.sharedService.emitRemovePreferenceEvent.emit(perferenceData);
  }
}
